import request from "@/api";

export function ListUserLoginLog(data) {
    return request({
        url: '/api/log/getLoginLog',
        method: 'get',
        params: data
    })
}

export function ListUserOperateLog(data) {
    return request({
        url: '/api/log/getOperateLog',
        method: 'get',
        params: data
    })
}